import React from 'react';
import { splitDomain } from '../../utils/splitDomain';
import * as S from './DomainString.styled';
export const DomainString = ({ domain }) => {
    const { mainDomain, tld } = splitDomain(domain);
    return (React.createElement(React.Fragment, null,
        mainDomain,
        tld && React.createElement(S.Suffix, null,
            ".",
            tld)));
};
